<template>
  <modal
    :exibir="exibir"
    @fechar="fecharModal"
    :titulo="'Tipo avaliação'"
    :campos="$refs"
    id="modalTipoAvaliacao"
  >
    <form-tipo-avaliacao :form="form" @refs="capturarRefs" />
    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvar">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Services:
import TipoAvaliacaoService from '@/common/services/academico/tipoAvaliacao.service.js';

// Components:
import Modal from '@/components/modal/Modal.vue';
import FormTipoAvaliacao from './Form';

export default {
  props: {
    exibir: { type: Boolean, default: false },
    form: { type: Object, default: Object },
  },
  components: {
    Modal,
    FormTipoAvaliacao,
  },
  data() {
    return {
      refs: [],
    };
  },
  methods: {
    // FUNÇÕES MODAL:
    fecharModal() {
      this.$emit('fechar');
    },
    // FUNÇÕES CRUD:
    salvar() {
      if (!this.validarFormulario()) return;
      this.form.id ? this.editar() : this.criar();
    },
    criar() {
      this.$store.dispatch(START_LOADING);
      TipoAvaliacaoService.criar(this.form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO', 'Tipo de avaliação criada!')
          );
          this.$emit('atualizar-tabela');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.fecharModal();
          this.$store.dispatch(STOP_LOADING);
        });
    },
    editar() {
      this.$store.dispatch(START_LOADING);
      TipoAvaliacaoService.editar(this.form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO', 'Tipo de avaliação atualizada!')
          );
          this.$emit('atualizar-tabela');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.fecharModal();
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES AUXILIARES:
    validarFormulario() {
      return helpers.validarFormulario(this.refs);
    },
    capturarRefs(refs) {
      this.refs = refs;
    },
  },
};
</script>
